import { SqsEvents } from "./sqsEvents";
import { trackingSourceList } from "./trackingSourceList";
/**
 * Pairs `actSignUp` then `actMarketingActivity` after successful signup.
 * Callers supply resolved `pageUrl` / `referrerUrl` (platform-specific).
 */
export function emitSignupLsq(args) {
    const { details, fallbackFirstName, fallbackLastName, selectedGrade, variant, } = args;
    const utmParams = buildDeepLinkUrl(args.pageUrl, args.referrerUrl, variant);
    console.log("utmParams emitSignupLsq", utmParams);
    const uad = details.user_account_details;
    const profiles = details.profiles;
    const ilProfile = profiles?.filter((p) => p.vertical_id === 1)[0];
    const examNames = ilProfile?.exams
        ?.map((e) => e.name)
        .filter(Boolean)
        .join(",") || undefined;
    const studentName = [uad?.first_name, uad?.last_name].filter(Boolean).join(" ").trim() ||
        `${fallbackFirstName} ${fallbackLastName}`.trim() ||
        undefined;
    const resGrade = uad?.grade;
    const grade = resGrade?.gradeId ?? selectedGrade;
    const baseLead = {
        academicGrade: resGrade?.gradeId,
        userFullName: studentName,
        userEmail: typeof uad?.email === "string" ? uad.email.trim() : undefined,
        optInDate: SqsEvents.getUtcDateTime(),
    };
    /** Signup lead carries both merged page URL and raw referrer when available. */
    const lead = {
        ...baseLead,
        utmCampaign: utmParams.utm_campaign,
        utmMedium: utmParams.utm_medium,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
        pageUrl: utmParams.completeUrl,
        referrerUrl: utmParams.referrerUrl,
        productOrigin: utmParams.tracking_source ??
            (args.variant === "web"
                ? trackingSourceList.Il_website
                : trackingSourceList.learn_an),
    };
    let signUpIntent;
    let marketingIntent;
    if (variant === "mobile") {
        signUpIntent = {
            utmUrl: utmParams.completeUrl,
            utmSource: utmParams.utm_source,
            utmCampaign: utmParams.utm_campaign,
            utmContent: utmParams.utm_content,
            utmMedium: utmParams.utm_medium,
            referralPage: utmParams.referrerUrl,
            unifiedAccountId: details.unified_account_id,
            grade,
            studentName,
            examName: examNames,
            productVertical: ilProfile?.vertical_id?.toString(),
            parentOrStudent: "Student",
            utmTerm: utmParams.utm_term,
            utmId: utmParams.utm_id,
        };
        marketingIntent = {
            utmUrl: utmParams.completeUrl,
            utmSource: utmParams.utm_source,
            utmCampaign: utmParams.utm_campaign,
            utmContent: utmParams.utm_content,
            utmMedium: utmParams.utm_medium,
            utmId: utmParams.utm_id,
            utmTerm: utmParams.utm_term,
            referralPage: utmParams.referrerUrl,
            grade,
            studentName,
            examName: examNames,
            productVertical: ilProfile?.vertical_id?.toString(),
            parentOrStudent: "Student",
        };
    }
    else {
        signUpIntent = {
            utmUrl: utmParams.completeUrl,
            utmSource: utmParams.utm_source,
            utmCampaign: utmParams.utm_campaign,
            utmContent: utmParams.utm_content,
            utmMedium: utmParams.utm_medium,
            referralPage: utmParams.referrerUrl,
            unifiedAccountId: details.unified_account_id,
            grade,
            studentName,
            examName: examNames,
            productVertical: ilProfile?.vertical_id?.toString(),
            parentOrStudent: "Student",
            utmTerm: utmParams.utm_term,
            utmId: utmParams.utm_id,
        };
        marketingIntent = {
            utmUrl: utmParams.completeUrl,
            utmSource: utmParams.utm_source,
            utmCampaign: utmParams.utm_campaign,
            utmContent: utmParams.utm_content,
            utmMedium: utmParams.utm_medium,
            utmId: utmParams.utm_id,
            utmTerm: utmParams.utm_term,
            referralPage: utmParams.referrerUrl,
            grade,
            studentName,
            examName: examNames,
            productVertical: ilProfile?.vertical_id?.toString(),
            parentOrStudent: "Student",
        };
    }
    SqsEvents.actSignUp(signUpIntent, lead);
    SqsEvents.actMarketingActivity(marketingIntent, lead);
}
export function emitPostAuthMarketingLsq(args) {
    const utmParams = buildDeepLinkUrl(args.leadPageContext?.pageUrl, args.leadPageContext?.referrerUrl, args.variant);
    console.log("utmParams Marketing", utmParams);
    const prospectId = args.prospectId?.trim() || undefined;
    const baseLead = {
        academicGrade: args.academicGrade,
        userFullName: args.studentName,
        userEmail: args.userEmail,
        optInDate: SqsEvents.getUtcDateTime(),
        ...(prospectId ? { searchBy: "prospect_id", prospect_id: prospectId } : {}),
    };
    const lead = {
        ...baseLead,
        utmCampaign: utmParams.utm_campaign,
        utmMedium: utmParams.utm_medium,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
        pageUrl: utmParams.completeUrl,
        referrerUrl: utmParams.referrerUrl,
        productOrigin: utmParams.tracking_source ??
            (args.variant === "web"
                ? trackingSourceList.Il_website
                : trackingSourceList.learn_an),
    };
    const intent = {
        grade: args.grade,
        studentName: args.studentName,
        examName: args.examName,
        productVertical: args.productVertical,
        parentOrStudent: "Student",
        utmUrl: utmParams.completeUrl,
        utmSource: utmParams.utm_source,
        utmCampaign: utmParams.utm_campaign,
        utmContent: utmParams.utm_content,
        utmMedium: utmParams.utm_medium,
        utmId: utmParams.utm_id,
        utmTerm: utmParams.utm_term,
        referralPage: utmParams.referrerUrl,
    };
    SqsEvents.actMarketingActivity(intent, lead);
}
/** Deeplink + optional Play install referrer; UTMs from deeplink only when both are set (Android parity). */
export function buildDeepLinkUrl(url, referrerUrl, variant) {
    const isWeb = variant === "web";
    const u = typeof url === "string" ? url.trim() : "";
    const ref = typeof referrerUrl === "string" ? referrerUrl.trim() : "";
    if (!u && !ref) {
        return {
            completeUrl: null,
            referrerUrl: null,
            utm_source: null,
            utm_medium: null,
            utm_content: null,
            utm_campaign: null,
            utm_term: null,
            utm_id: null,
            tracking_source: null,
        };
    }
    let completeUrl;
    let sp;
    if (u && ref) {
        const uParams = (() => {
            try {
                return new URL(u).searchParams;
            }
            catch {
                const i = u.indexOf("?");
                return i === -1
                    ? new URLSearchParams()
                    : new URLSearchParams(u.slice(i + 1));
            }
        })();
        const refParams = (() => {
            try {
                return new URL(ref).searchParams;
            }
            catch {
                return new URLSearchParams(ref.startsWith("?") ? ref.slice(1) : ref);
            }
        })();
        sp = new URLSearchParams(refParams);
        uParams.forEach((value, key) => {
            sp.set(key, value);
        });
        try {
            const parsed = new URL(u);
            parsed.search = sp.toString();
            completeUrl = parsed.toString();
        }
        catch {
            const qIndex = u.indexOf("?");
            const base = qIndex === -1 ? u : u.slice(0, qIndex);
            const query = sp.toString();
            completeUrl = query ? `${base}?${query}` : base;
        }
    }
    else if (u) {
        try {
            const parsed = new URL(u);
            completeUrl = parsed.toString();
            sp = parsed.searchParams;
        }
        catch {
            completeUrl = u;
            const i = u.indexOf("?");
            sp =
                i === -1 ? new URLSearchParams() : new URLSearchParams(u.slice(i + 1));
        }
    }
    else {
        completeUrl = ref;
        sp = new URLSearchParams(ref);
    }
    const rawTs = sp.get("tracking_source");
    return {
        completeUrl,
        referrerUrl,
        utm_source: sp.get("utm_source"),
        utm_medium: sp.get("utm_medium"),
        utm_content: sp.get("utm_content"),
        utm_campaign: sp.get("utm_campaign"),
        utm_term: sp.get("utm_term"),
        utm_id: sp.get("utm_id"),
        tracking_source: rawTs !== null
            ? (trackingSourceList[rawTs] ??
                (isWeb ? trackingSourceList.Il_website : trackingSourceList.learn_an))
            : isWeb
                ? trackingSourceList.Il_website
                : trackingSourceList.learn_an,
    };
}
